const API_BASE = `${process.env.REACT_APP_API_URL || ""}/api/v1`;
const WEB_LINK = "sgquitsmoking";
const VISITOR_ID_KEY = "sgqs-analytics-visitor-id";
const SESSION_ID_KEY = "sgqs-analytics-session-id";
const UTM_STORAGE_KEY = "sgqs-analytics-utm";

const SEARCH_ENGINES = [
  { name: "Google", pattern: /(^|\.)google\./i },
  { name: "Bing", pattern: /(^|\.)bing\./i },
  { name: "Yahoo", pattern: /(^|\.)yahoo\./i },
  { name: "DuckDuckGo", pattern: /(^|\.)duckduckgo\./i },
  { name: "Baidu", pattern: /(^|\.)baidu\./i },
  { name: "Yandex", pattern: /(^|\.)yandex\./i },
];

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `v-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}

function getVisitorId() {
  let id = localStorage.getItem(VISITOR_ID_KEY);
  if (!id) {
    id = randomId();
    localStorage.setItem(VISITOR_ID_KEY, id);
  }
  return id;
}

function getSessionId() {
  let id = sessionStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = randomId();
    sessionStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
}

function readStoredUtm() {
  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY);
    if (!raw) return { utmSource: "", utmMedium: "", utmCampaign: "" };
    const parsed = JSON.parse(raw);
    return {
      utmSource: String(parsed?.utm_source || parsed?.utmSource || ""),
      utmMedium: String(parsed?.utm_medium || parsed?.utmMedium || ""),
      utmCampaign: String(parsed?.utm_campaign || parsed?.utmCampaign || ""),
    };
  } catch {
    return { utmSource: "", utmMedium: "", utmCampaign: "" };
  }
}

function saveUtmFromSearch(searchParams) {
  const nextUtm = {
    utm_source: String(searchParams.get("utm_source") || "").trim(),
    utm_medium: String(searchParams.get("utm_medium") || "").trim(),
    utm_campaign: String(searchParams.get("utm_campaign") || "").trim(),
  };
  if (nextUtm.utm_source || nextUtm.utm_medium || nextUtm.utm_campaign) {
    localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(nextUtm));
    return {
      utmSource: nextUtm.utm_source,
      utmMedium: nextUtm.utm_medium,
      utmCampaign: nextUtm.utm_campaign,
    };
  }
  return readStoredUtm();
}

function referrerDomainFromUrl(referrer) {
  if (!referrer) return "";
  try {
    return new URL(referrer).hostname.replace(/^www\./i, "");
  } catch {
    return "";
  }
}

function detectSearchEngine(domain) {
  if (!domain) return { isSearchReferral: false, searchEngine: "" };
  for (const engine of SEARCH_ENGINES) {
    if (engine.pattern.test(domain)) {
      return { isSearchReferral: true, searchEngine: engine.name };
    }
  }
  return { isSearchReferral: false, searchEngine: "" };
}

function parseUserAgent(ua) {
  const value = ua || "";
  let device = "desktop";
  if (/mobile|iphone|ipod|android.*mobile|windows phone/i.test(value)) {
    device = "mobile";
  } else if (/ipad|tablet|android(?!.*mobile)/i.test(value)) {
    device = "tablet";
  }

  let browser = "unknown";
  if (/edg\//i.test(value)) browser = "Edge";
  else if (/chrome\//i.test(value) && !/edg\//i.test(value)) browser = "Chrome";
  else if (/safari\//i.test(value) && !/chrome\//i.test(value)) browser = "Safari";
  else if (/firefox\//i.test(value)) browser = "Firefox";
  else if (/opr\//i.test(value) || /opera/i.test(value)) browser = "Opera";

  let os = "unknown";
  if (/windows nt/i.test(value)) os = "Windows";
  else if (/mac os x/i.test(value) && !/iphone|ipad|ipod/i.test(value)) os = "macOS";
  else if (/iphone|ipad|ipod/i.test(value)) os = "iOS";
  else if (/android/i.test(value)) os = "Android";
  else if (/linux/i.test(value)) os = "Linux";

  return { browser, device, os };
}

function buildHitPayload() {
  const searchParams = new URLSearchParams(window.location.search);
  const referrer = document.referrer || "";
  const referrerDomain = referrerDomainFromUrl(referrer);
  const { isSearchReferral, searchEngine } = detectSearchEngine(referrerDomain);
  const { browser, device, os } = parseUserAgent(navigator.userAgent || "");
  const utm = saveUtmFromSearch(searchParams);
  const path =
    window.location.pathname +
    (searchParams.toString() ? `?${searchParams.toString()}` : "");

  return {
    webLink: WEB_LINK,
    visitorId: getVisitorId(),
    sessionId: getSessionId(),
    path,
    referrer,
    referrerDomain,
    utmSource: utm.utmSource,
    utmMedium: utm.utmMedium,
    utmCampaign: utm.utmCampaign,
    isSearchReferral,
    searchEngine,
    browser,
    device,
    os,
  };
}

function postAnalytics(path, body) {
  return fetch(`${API_BASE}${path}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "ngrok-skip-browser-warning": "true",
    },
    body: JSON.stringify(body),
    keepalive: true,
  }).catch(() => {});
}

export function recordPageView() {
  return postAnalytics("/simon-analytics/hit", buildHitPayload());
}

export function recordInviteClick() {
  return postAnalytics("/simon-analytics/click", { webLink: WEB_LINK });
}
